import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const RelatedLinks = ({ title, relatedLinks = [] }) => (
    <section className="related-links">
        <h2>{title}</h2>
        <ul>
            {relatedLinks.map((link, idx) => (
                <li key={idx}>
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <a href={link.url}
                        className="related-link"
                        target={link.openInNewTab ? '_blank' : ''}>
                        {link.text}
                    </a>
                </li>
            ))}
        </ul>
    </section>
);

RelatedLinks.propTypes = {
    relatedLinks: PropTypes.array,
    title: PropTypes.string
};

export default RelatedLinks;
